/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as o from "react";
import { useLocalization as a } from "@progress/kendo-react-intl";
import { noRecords as e, messages as n } from "../../messages/index.mjs";
const i = (r) => {
  const t = a();
  return /* @__PURE__ */ o.createElement(o.Fragment, null, r.children || t.toLanguageString(e, n[e]));
};
i.displayName = "KendoReactGridNoRecords";
export {
  i as GridNoRecords
};
